import type { SortModel } from '../../data/sort-model';

export class SortAction<T> {
  static readonly type = '[Table] Sort';

  constructor(readonly sort: SortModel<T>) {}
}
